import React from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  CssBaseline,
  CardActions,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Button,
  ButtonBase,
  Paper,
  Grid,
} from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import DirectionsIcon from "@material-ui/icons/Directions";
import { makeStyles } from "@material-ui/core/styles";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import DoctorImg from "../../../img/doctor.png";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const SearchDoctorCardView = (props) => {
  const doctor = props.doctor;
  const showBookNowBtn = props.showBookNowBtn;
  const handleBookAppointment = props.handleBookAppointment;
  const classes = useStyles();

  return (
    
      <Box pt={2} pr={1} pb={1} pl={2}>
        <Paper elevation={0}>
        <CssBaseline />
        {props.showEdit?
         <Grid container spacing={2} alignItems="center" wrap="nowrap">
         <Grid item sm={10}>
           <Box clone>
           <Typography gutterBottom variant="subtitle1" color="secondary">
           Doctor's Calendar is blocked. Please choose another doctor.
              </Typography>
           </Box>
         </Grid>
         <Grid item sm={2}>
           <Box clone>
            <Button
            variant="contained"
                  color="secondary"
                  className={classes.iconButton}
                  onClick={() => {
                    props.chooseDifferentDoctor();
                  }}
                >
                  Choose
                </Button>
           </Box>
         </Grid>
         </Grid>
        :null}


          <Grid container spacing={2} alignItems="center" wrap="nowrap">
            <Grid item sm={2}>
              <Box clone>
                <Avatar>
                  <img className={classes.img} alt="complex" src={DoctorImg} />
                </Avatar>
              </Box>
            </Grid>
            <Grid item sm={6}>
              <Typography gutterBottom variant="subtitle1" color="primary">
                {doctor.firstName + " " + doctor.lastName}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Specialized in {doctor.speciality.join(" , ")}
              </Typography>
            </Grid>
            <Grid item sm={4}>
            <Grid container justify="flex-end" spacing={1}>
            <Grid item>
              {showBookNowBtn ? (
                <Button
                  color="primary"
                  className={classes.iconButton}
                  onClick={() => {
                    handleBookAppointment(doctor.id);
                  }}
                >
                  Book now
                </Button>
              ) : null}
            </Grid>
          </Grid>
            </Grid>
          </Grid>
          
        </Paper>
      </Box>
    
  );
};

SearchDoctorCardView.propTypes = {
  doctor: PropTypes.object.isRequired,
  showBookNowBtn: PropTypes.bool.isRequired,
};

export default SearchDoctorCardView;
